import { parseISO, isBefore, startOfDay } from "date-fns";
import { PurchaseOrder } from "@/redux/services/inventory/inventory.type";

export const isPurchaseOrderOverdue = (po: PurchaseOrder): boolean => {
  if (!po.expectedDeliveryDate) return false;
  if (po.status !== "sent" && po.status !== "partially_received") return false;
  return isBefore(parseISO(po.expectedDeliveryDate), startOfDay(new Date()));
};

interface OverduePillProps {
  className?: string;
}

const OverduePill = ({ className }: OverduePillProps) => (
  <span
    className={
      "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-700 " +
      (className ?? "")
    }
  >
    En retard
  </span>
);

export default OverduePill;
